module.exports = __webpack_public_path__ + "img/read.be5030ca.webp";